import { render, staticRenderFns } from "./RecordSearchList.vue?vue&type=template&id=68f571f8&"
import script from "./RecordSearchList.vue?vue&type=script&lang=js&"
export * from "./RecordSearchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports